import { adminRecords } from "./adminRecords";
import { useEffect, useMemo, useState } from "react";
import update from "react-addons-update";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import CopyToClipboardButton from "./CopyToClipboardButton.tsx";

function Documents(props) {
  const showUserColumn = props.showUserColumn !== undefined ? props.showUserColumn : true;
  const [results, setResults] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setPage] = useState(1);

  async function query(page) {
    const ref = adminRecords.collection("documents");
    let query;
    let set = {};

    if (queries[page]) {
      query = queries[page];
    } else {
      query = ref.limit(25).orderBy("createdAt", "desc");

      if (page != 1) {
        // look at previous page to build next query
        let result = results[page - 1];

        if (result) {
          query = query.startAfter(result[result.length - 1]);
        } else {
          console.log("Cannot construct a query for a page that is not adjacent to one already fetched");
        }
      }

      setQueries(update(queries, { [page]: { $set: query } }));
    }

    if (props.user) {
      query = query.where("userId", "==", props.user.uid);
    }

    let querySnapshot = await query.get();

    set.documents = querySnapshot.docs;

    if (showUserColumn && props.userCache) {
      await props.userCache.fetchIds(querySnapshot.docs.map((s) => s.get("userId")));
    }

    setDocuments(querySnapshot.docs);
    setResults(update(results, { [page]: { $set: querySnapshot.docs } }));
    setLoading(false);
  }

  useEffect(() => {
    query(currentPage);
  }, [currentPage]);

  const columns = useMemo(() => {
    const cols = [
      {
        name: "ID",
        width: "220px",
        selector: (row) => {
          return row.id;
        },
        sortable: false,
        cell: (row) => (
          <CopyToClipboardButton
            textToCopy={row.id}
            successMessage={`Copied ID to clipboard: ${row.id}`}
            className="font-mono w-full"
          />
        ),
      },
      {
        name: "Created At",
        width: "140px",
        selector: (row) => {
          return row.get("createdAt").toDate().toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });
        },
        sortable: false,
        cell: (row) => (
          <div className="text-xs text-gray-600">
            {row.get("createdAt").toDate().toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        ),
      },
      {
        name: "Content",
        width: "300px",
        selector: () => {
          return "need updating to ydoc.";
        },
        sortable: false,
        cell: () => <div className="text-sm text-gray-500 italic">need updating to ydoc.</div>,
      },
    ];

    if (showUserColumn) {
      cols.splice(2, 0, {
        name: "User",
        width: "200px",
        selector: (row) => {
          const user = props.userCache?.getUser(row.get("userId"));
          return user ? user.displayName || user.email : "User Deleted";
        },
        sortable: false,
        cell: (row) => {
          const user = props.userCache?.getUser(row.get("userId"));
          if (user) {
            return (
              <Link
                to={"/admin/user/" + user.email}
                className="text-app-primary-cta hover:underline px-1 py-1 rounded-md"
              >
                {user.displayName || user.email}
              </Link>
            );
          }
          return <span className="text-gray-500 italic">User Deleted</span>;
        },
      });
    }

    return cols;
  }, [props.userCache, showUserColumn]);

  return (
    <div className="p-4">
      <DataTable
        columns={columns}
        responsive={true}
        progressPending={loading}
        pagination
        paginationServer
        paginationPerPage={25}
        paginationRowsPerPageOptions={[25]}
        paginationTotalRows={99999999}
        onChangePage={(page) => {
          setPage(page);
        }}
        data={documents}
      />
    </div>
  );
}

export default Documents;
